import * as Sentry from '@sentry/browser';

// Expose the SDK; the actual Sentry.init() call lives readable in
// templates/base_page.html (same pattern as the analytics snippet).
window.Sentry = Sentry;
